import React, { Component } from 'react';
import { connect } from 'react-redux';
import withModal from '../../../../lib/hoc/withModal';
import { tagActions } from '../../../../store/modules/tag';
import PreviewTagTrendKeywordModal from '../../../../views/tag/common/modal/PreviewTagTrendKeywordModal';

class PreviewTagTrendKeywordModalContainer extends Component {
  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'tagTrendKeywordPreviewModal', value: false });
  };

  render() {
    return <PreviewTagTrendKeywordModal {...this.state} {...this.props} closeModal={this.closeModal} />;
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.tag.tagTrendKeywordPreviewModal.isOpen,
    data: state.tag.tagTrendKeywordPreviewModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: tagActions.toggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(PreviewTagTrendKeywordModalContainer));
